import { AbstractControl, ValidatorFn } from '@angular/forms';

export class EmailValidator {
  static emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  static email(): ValidatorFn {
    return (control: AbstractControl) => {
      const raw = control.value;
      if (raw == null) {
        return null;
      }
      const email = String(raw).trim();

      if (!email.length || this.emailRegex.test(email)) {
        return null;
      }
      return { invalidEmail: true };
    };
  }
}
